function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 14.25a.75.75 0 01.75.75A7.745 7.745 0 0115 22.75a.75.75 0 01-.643-1.136l1.05-1.75a.75.75 0 111.286.772l-.271.452A6.246 6.246 0 0021.25 15a.75.75 0 01.75-.75zM7.578 2.912A6.246 6.246 0 002.75 9a.75.75 0 01-1.5 0A7.745 7.745 0 019 1.25a.75.75 0 01.643 1.136l-1.05 1.75a.75.75 0 01-1.286-.772l.271-.452z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 15.7v.61H2v-.61c0-1.76.44-2.2 2.22-2.2h5.56c1.78 0 2.22.44 2.22 2.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 16.31v3.49c0 1.76.44 2.2 2.22 2.2h5.56c1.78 0 2.22-.44 2.22-2.2v-3.49H2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 4.2v.61H12V4.2c0-1.76.44-2.2 2.22-2.2h5.56C21.56 2 22 2.44 22 4.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4.81V8.3c0 1.76.44 2.2 2.22 2.2h5.56c1.78 0 2.22-.44 2.22-2.2V4.81H12z"
})));